import React from 'react';
import { withStyles, WithStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import {
  QuoteIcon as QuickLinksIcon
} from '@markinson/uicomponents-v2/SvgIcons/';
import styles from './QuickLinksWidget.styles';
import { useFetchDashboardQuickLinks } from 'api/dashboardMaintenanceEnquiry/dashboardMaintenanceEnquiry';
import { RouteComponentProps, withRouter } from 'react-router';
import { generateURL } from '../Widgets.utils';

export interface IQuickLinksWidgetProps extends WithStyles<typeof styles>, RouteComponentProps {
  selectedDashboardId?: number;
}

const QuickLinksWidget: React.FC<IQuickLinksWidgetProps> = React.memo(({ classes, selectedDashboardId, history, location }) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const { data: dashboardQuickLinksData } = useFetchDashboardQuickLinks(selectedDashboardId);

  const sequencedQuickLinks = React.useMemo(
    () => {

      return dashboardQuickLinksData?.DashboardQuickLinks?.sort((a, b) => a?.Sequence - b?.Sequence) || [];
    },
    [dashboardQuickLinksData?.DashboardQuickLinks]
  );

  const isQuickLinksDisabled = !dashboardQuickLinksData?.EnableQuickLinks || sequencedQuickLinks.length === 0;

  const handleOpenMenu = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  return (
    <div className={classes.toolbar}>
      <Button
        className={classes.quickLinksButton}
        onClick={handleOpenMenu}
        disabled={isQuickLinksDisabled}
      >
        <QuickLinksIcon disabled={isQuickLinksDisabled} style={{ width: 40, height: 40 }} />
        <span className={`${classes.quickLinksText} ${isQuickLinksDisabled ? classes.disabled : ''}`}>
          Quick Links
        </span>
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleCloseMenu}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        PaperProps={{
          style: {
            maxHeight: 300,
            overflowY: 'auto',
          },
        }}
      >
        {sequencedQuickLinks?.map((link) => (
          <MenuItem
            key={link.QuickLinkId}
            className={classes.menuItem}
            onClick={() => {
              history.push(generateURL(location, link.URL));
              handleCloseMenu();
            }}
          >
            {link.Label}
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
});

export default withRouter(withStyles(styles)(QuickLinksWidget));
